'use client';

import { useAtomValue } from '@effect/atom-react';

import { SearchSuggestResultsView } from './SearchSuggestResultsView';
import { getSearchSuggestAtom } from '../../../effect/atom/search/searchSuggestAtom';

type Props = {
  query: string;
  onSelectAction: () => void;
};

export default function SearchSuggestResults({ query, onSelectAction }: Props) {
  const result = useAtomValue(getSearchSuggestAtom(query));

  return <SearchSuggestResultsView result={result} query={query} onSelectAction={onSelectAction} />;
}
